function average(values) {
    if (!values || !values.length) return 0;

    let total = 0;

    for (let value of values) {
        total += +value;
    }

    const average = +(total / values.length).toFixed(1);

    return average ? average : 0;
}

function normalization(average, targetValue) {
    const normalized = +((+average / +targetValue) * 100).toFixed(1);
    return normalized ? normalized : 0;
}

function simpleNormalization(average, targetValue) {
    const normalized = +(+average / +targetValue).toFixed(1);
    return normalized ? normalized : 0;
}

function strengthCapacityScore(average, targetValue) {
    const CONST_PERCENT = 68;
    const CONST_DIVISOR = 15;
    const result = ((+average * ((+targetValue * CONST_PERCENT) / 100)) / CONST_DIVISOR).toFixed(1);

    return result ? result : 0;
}

function copenhagenRisk(seconds) {
    const value = +seconds;

    if (isNaN(value)) return null;

    if (value < 20) return { level: 'muito-alto', label: 'Muito Alto', emoji: '🔴', textClass: 'text-red-600' };
    if (value < 30) return { level: 'alto', label: 'Alto', emoji: '🟠', textClass: 'text-orange-500' };
    if (value < 45) return { level: 'moderado', label: 'Moderado', emoji: '🟡', textClass: 'text-yellow-500' };

    return { level: 'baixo', label: 'Baixo', emoji: '🟢', textClass: 'text-lime-600' };
}

function asymmetry(a, b) {
    if (a === 0 && b === 0) {
        return 0;
    }
    
    let asymmetry = 0;

    if (a > b) {
        asymmetry = ((a - b) / a * 100);
    } else if(a < b) {
        asymmetry = ((b - a) / b * 100);
    } else {
        asymmetry = ((a - b) / a * 100);
    }
    
    return Math.abs(asymmetry).toFixed(1);
}

// Complemento direto da assimetria: o quanto os dois lados se parecem, em vez do quanto
// diferem. symmetry(a, b) + asymmetry(a, b) = 100.
function symmetry(a, b) {
    const values = [+a, +b];

    if (values.some((value) => !Number.isFinite(value)) || Math.max(...values) === 0) {
        return 0;
    }

    return +((Math.min(...values) / Math.max(...values)) * 100).toFixed(1);
}

export default {
    asymmetry,
    symmetry,
    average,
    normalization,
    simpleNormalization,
    strengthCapacityScore,
    copenhagenRisk
}